'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIXABLE_PROPS = exports.PREFIXABLE_PROPS = ['accelerator', 'animation', 'appearance', 'aspectRatio', 'backdropFilter', 'backfaceVisibility', 'backgroundComposite', 'binding', 'blockProgression', 'borderAfter', 'borderBefore', 'borderEnd', 'borderFit', 'borderStart', 'borderVerticalSpacing', 'box', 'column', 'filter', 'flex', 'flow', 'fontFeatureSettings', 'fontSizeDelta', 'fontSmoothing', 'grid', 'hyphenate', 'hyphens', 'imageRegion', 'initialLetter', 'line', 'locale', 'logical', 'marginAfter', 'marginBefore', 'marginBottomCollapse', 'marginCollapse', 'marginEnd', 'marginFit', 'marginStart', 'marginTopCollapse', 'marquee', 'mask', 'math', 'objectFit', 'perspective', 'scrollSnap', 'textAlignLast', 'textDecoration', 'textFill', 'textJustify', 'textOrientation', 'textSecurity', 'textSizeAdjust', 'textStroke', 'textUnderline', 'textZoom', 'textOverflow', 'transform', 'userSelect', 'wordBreak', 'wrap'];

var ALTERNATE_PROPS = exports.ALTERNATE_PROPS = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

var PREFIXABLE_VALUES = exports.PREFIXABLE_VALUES = ['grid', 'inline-grid', 'linear-gradient', 'radial-gradient', 'repeating-linear-gradient', 'repeating-radial-gradient'];

var ALTERNATE_VALUES = exports.ALTERNATE_VALUES = {
  'break-all': ['break-word'],
  'flex': ['-webkit-box', '-ms-flexbox', '-webkit-flex'],
  'flex-end': ['end'],
  'flex-start': ['start'],
  'space-around': ['distribute'],
  'space-between': ['justify']
};